import { render } from "./OffertaEditDialog.vue?vue&type=template&id=765a9a76&scoped=true"
import script from "./OffertaEditDialog.vue?vue&type=script&lang=js"
export * from "./OffertaEditDialog.vue?vue&type=script&lang=js"

import "./OffertaEditDialog.vue?vue&type=style&index=0&id=765a9a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765a9a76"]])

export default __exports__